// extracted by mini-css-extract-plugin
export default {"GsdSectionTitle":"GSDSectionTitle_GsdSectionTitle__0V0Jt","titleStyle":"GSDSectionTitle_titleStyle__ZsRQi"};